import { API_PATH } from "api/ApiPath";
import { ListBaseApiResponseModel } from "api/baseApiResponseModel/ListBaseApiResponseModel";
import client from "api/client";
import { injectable } from "tsyringe";
import { NotificationRequestModel } from "./model/NotificationRequestModel";
import { NotificationResponseModel } from "./model/NotificationResponseModel";

export interface INotificationRepository {
  getNoti(
    params: NotificationRequestModel
  ): Promise<ListBaseApiResponseModel<NotificationResponseModel>>;
}

@injectable()
export class NotificationImpl implements INotificationRepository {
  async getNoti(
    params: NotificationRequestModel
  ): Promise<ListBaseApiResponseModel<NotificationResponseModel>> {
    return await client?.get(API_PATH.NOTI_LIST, params);
  }
}
